import request from '@/config/axios'

// ==================== 景区订单 VO ====================
export interface ScenicOrderVO {
  id?: number
  orderNo?: string                           // 订单编号
  userId?: number                            // 用户ID
  userNickname?: string                      // 用户昵称
  userMobile?: string                        // 用户手机号
  scenicId?: number                          // 景区ID
  scenicName?: string                        // 景区名称
  routeId?: number                           // 线路ID
  routeName?: string                         // 线路名称
  packageId?: number                         // 套餐ID
  packageName?: string                       // 套餐名称
  ticketType?: number                        // 票种：1成人 2儿童 3老人 4军人
  ticketTypeName?: string                    // 票种名称
  quantity?: number                          // 数量
  ticketTierName?: string                    // 票型名称
  adultCount?: number
  childCount?: number
  elderlyCount?: number
  militaryCount?: number
  totalCount?: number                        // 总人数
  unitPrice?: number                         // 单价
  totalPrice?: number                        // 原价总金额
  discountPrice?: number                     // 优惠金额
  payPrice?: number                          // 实付金额
  status?: number                            // 订单状态：0待支付 1已支付 2已核销 3已退款 4已取消 5已过期
  statusName?: string                        // 订单状态名称
  payChannelCode?: string                    // 支付渠道
  payChannelName?: string                    // 支付渠道名称
  payTime?: string                           // 支付时间
  verifyCode?: string                        // 核销码
  verifyTime?: string                        // 核销时间
  verifyUserId?: number                      // 核销人ID
  verifyUserName?: string                    // 核销人姓名
  refundTime?: string                        // 退款时间
  refundAmount?: number                      // 退款金额
  createTime?: string                        // 创建时间
  remark?: string                            // 备注
  // 使用日期信息
  useDate?: string                           // 使用日期
  contactName?: string                       // 联系人
  contactMobile?: string                     // 联系人手机
  merchantId?: number
  merchantName?: string
}

// ==================== 分页查询 ====================
export const getScenicOrderPage = (params: any) => {
  return request.get<PageResult<ScenicOrderVO[]>>({ url: '/scenic/order/page', params })
}

// ==================== 获取订单详情 ====================
export const getScenicOrder = (id: number) => {
  return request.get<ScenicOrderVO>({ url: '/scenic/order/get', params: { id } })
}

// ==================== 核销：按订单ID核销 ====================
export const verifyOrderById = (id: number) => {
  return request.put({ url: '/scenic/order/verify-by-id', params: { id } })
}

// ==================== 核销：按核销码核销 ====================
export const verifyOrderByCode = (verifyCode: string) => {
  return request.put({ url: '/scenic/order/verify-by-code', params: { verifyCode } })
}

// ==================== 根据核销码查询订单 ====================
export const getOrderByVerifyCode = (verifyCode: string) => {
  return request.get<ScenicOrderVO>({ url: '/scenic/order/get-by-verify-code', params: { verifyCode } })
}

// ==================== 取消订单 ====================
export const cancelOrder = (id: number) => {
  return request.put({ url: '/scenic/order/cancel', params: { id } })
}

// ==================== 退款 ====================
export const refundOrder = (id: number, refundAmount?: number, refundReason?: string) => {
  return request.put({ url: '/scenic/order/refund', params: { id, refundAmount, refundReason } })
}

// ==================== 导出 ====================
export const exportScenicOrderExcel = (params: any) => {
  return request.download({ url: '/scenic/order/export-excel', params })
}
